module.exports = __webpack_public_path__ + "static/media/no-data.2421fe06.png";